import { render, staticRenderFns } from "./InterbankTransaction.vue?vue&type=template&id=607e27d4"
import script from "./InterbankTransaction.vue?vue&type=script&lang=js"
export * from "./InterbankTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports